import React, { useEffect } from "react";
import { Table } from "antd";
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { useDispatch, useSelector } from "react-redux";
import RewardForm from "./RewardForm"; 
import PopupButton from "components/button/PopupButton";
import { handleTableChange } from "../../../../utils/index";
import {
  getRewardList,
  doRewardDelete,
  doRewardReset,
} from "../../../../redux/reward/rewardState";
import { displayIcon } from "variables/icons";
import { MODULE_REWARDS } from "variables/modules";

const RewardTable = ({ }) => {
    const dispatch = useDispatch();
    const recordList = useSelector((state) => state.reward.rewardList?.items);
    const pagination = useSelector((state) => state.reward.rewardList?.pagination);
    const filters = useSelector((state) => state.reward.rewardList?.filters);

    const doSearch = (filters) => dispatch(getRewardList(filters));
    const doDelete = (id) => dispatch(doRewardDelete(id));
    const doRecordReset = () => dispatch(doRewardReset());

  const columns = [
    {
      title: "Reward Title",
      dataIndex: "rwd_title",
      key: "rwd_title",
      width: "20%",
      render: (rwd_title) => <span>{rwd_title}</span>,
    },
    {
      title: "Icon",
      dataIndex: "rwd_icon",
      key: "rwd_icon",
      width: "6%",
      render: (rwd_icon) => <span>{displayIcon(rwd_icon, "w-5 h-5 title-text")}</span>,
    },
    {
      title: "Description",
      dataIndex: "rwd_description",
      key: "rwd_description",
      width: "50%",
      render: (rwd_description) => <span>{rwd_description}</span>,
    },

    {
      title: "Points",
      dataIndex: "rwd_points",
      key: "rwd_points",
      width: "10%",
      render: (rwd_description) => <span>{rwd_description}</span>,
    },
    {
      title: (
        <PopupButton id="add_reward" title="Add Reward" label="Add" btnClass="btn-small" action="add" moduleId={MODULE_REWARDS}>
          <RewardForm recordId="0" mode="edit" />
        </PopupButton>
      ),
      dataIndex: "rwd_id",
      key: "rwd_id",
      width: "10%",
      render: (_, record) => (
        <CrudOption
          baseRoute="/console/rewards"
          recordId={record?.rwd_id}
          deleteHandler={doDelete}
          allowEdit={true}
          allowView={false}
          editMode="modal"
          modalWidth={900}
          title="Edit reward"
          closeHandler={doRecordReset}
          editHandler={(recordId, doRecordReset ) => (
            <RewardForm recordId={recordId} mode="edit" onCancel={doRecordReset} />
          )}
        />
      ),
    },
  ];

	useEffect(() => {
		dispatch(getRewardList({paginate: pagination.per_page}));
	}, [dispatch, pagination.per_page]);
	
  return (
    <Card extra={"w-full h-full p-4"}>
      <div className="h-full overflow-x-scroll xl:overflow-x-hidden">
        <Table
          dataSource={recordList}
          columns={columns}
          rowKey={(record) => record.rwd_id}
          scroll={{ x: "max-content" }}
		      pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}   
          onChange={handleTableChange(doSearch, filters)}
        />
      </div>
    </Card>
  );
};

export default RewardTable;
